"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AreaOutcodeResponse$ = exports.AreaOutcodeResponse$outboundSchema = exports.AreaOutcodeResponse$inboundSchema = void 0;
exports.areaOutcodeResponseToJSON = areaOutcodeResponseToJSON;
exports.areaOutcodeResponseFromJSON = areaOutcodeResponseFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const areaoutcodewrapper_js_1 = require("./areaoutcodewrapper.js");
/** @internal */
exports.AreaOutcodeResponse$inboundSchema = z.object({
    data: z.array(areaoutcodewrapper_js_1.AreaOutcodeWrapper$inboundSchema),
});
/** @internal */
exports.AreaOutcodeResponse$outboundSchema = z.object({
    data: z.array(areaoutcodewrapper_js_1.AreaOutcodeWrapper$outboundSchema),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var AreaOutcodeResponse$;
(function (AreaOutcodeResponse$) {
    /** @deprecated use `AreaOutcodeResponse$inboundSchema` instead. */
    AreaOutcodeResponse$.inboundSchema = exports.AreaOutcodeResponse$inboundSchema;
    /** @deprecated use `AreaOutcodeResponse$outboundSchema` instead. */
    AreaOutcodeResponse$.outboundSchema = exports.AreaOutcodeResponse$outboundSchema;
})(AreaOutcodeResponse$ || (exports.AreaOutcodeResponse$ = AreaOutcodeResponse$ = {}));
function areaOutcodeResponseToJSON(areaOutcodeResponse) {
    return JSON.stringify(exports.AreaOutcodeResponse$outboundSchema.parse(areaOutcodeResponse));
}
function areaOutcodeResponseFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.AreaOutcodeResponse$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'AreaOutcodeResponse' from JSON`);
}
//# sourceMappingURL=areaoutcoderesponse.js.map